import { IconButton } from '@chakra-ui/react';
import { FaSyncAlt } from 'react-icons/fa';

// Floating page-refresh button: left side, 25px above the 50px fixed footer.
export default function RefreshPageButton() {
    return (
        <IconButton
            aria-label="Refresh page"
            title="Refresh"
            icon={<FaSyncAlt />}
            onClick={() => window.location.reload()}
            isRound
            size="md"
            colorScheme="blue"
            boxShadow="lg"
            position="fixed"
            left="16px"
            bottom="75px"
            zIndex={11}
        />
    );
}
